function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="22" height="22" viewBox="0 0 22 22" {...props}><path d="M10.81 0C4.84 0 0 4.84 0 10.81c0 5.97 4.84 10.81 10.81 10.81 5.97 0 10.81-4.84 10.81-10.81C21.62 4.84 16.78 0 10.81 0zm6.042 8.744l-6.81 6.81a.9.9 0 0 1-1.274 0l-3.11-3.11A.9.9 0 1 1 6.93 11.17l2.474 2.474 6.173-6.173a.9.9 0 1 1 1.274 1.273z" fillRule="nonzero" /></svg>;
});